export let BlobKey;
(function (BlobKey) {
  BlobKey[BlobKey["ImageBlob"] = 0] = "ImageBlob";
  BlobKey[BlobKey["AnimationBlob"] = 1] = "AnimationBlob";
})(BlobKey || (BlobKey = {}));